import { render, staticRenderFns } from "./RecipeInfoForm.vue?vue&type=template&id=0625b73c&scoped=true"
import script from "./RecipeInfoForm.vue?vue&type=script&lang=js"
export * from "./RecipeInfoForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeInfoForm.vue?vue&type=style&index=0&id=0625b73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625b73c",
  null
  
)

export default component.exports